import { createBrowserRouter, Navigate } from "react-router-dom";
import AppLayout from "@/components/layout/AppLayout";
import RootErrorBoundary from "@/components/ErrorBoundary";

import ContentHubPage     from "@/pages/content-hub/page";
import AiCreatorPage      from "@/pages/ai-creator/page";
import ContentLibraryPage from "@/pages/content-library/page";
import StrategyHubPage    from "@/pages/strategy-hub/page";
import GscOverviewPage    from "@/pages/gsc-overview/page";
import SettingsPage       from "@/pages/settings/page";

/**
 * Routes map.
 *
 * The entire app shares the three-column `AppLayout` (sidebar + main + agent
 * panel). Individual pages can still opt to hide the agent panel by rendering
 * their own `<AppLayout showAgent={false}>` inside the page component, as the
 * previous Next.js code did. The root layout route just provides a default.
 */
export const router = createBrowserRouter([
  {
    path: "/",
    errorElement: <RootErrorBoundary />,
    children: [
      { index: true, element: <Navigate to="/content-hub" replace /> },
      { path: "content-hub",     element: <ContentHubPage /> },
      { path: "ai-creator",      element: <AiCreatorPage /> },
      { path: "content-library", element: <ContentLibraryPage /> },
      { path: "strategy-hub",    element: <StrategyHubPage /> },
      { path: "gsc-overview",    element: <GscOverviewPage /> },
      { path: "settings",        element: <SettingsPage /> },
      { path: "*", element: <Navigate to="/content-hub" replace /> },
    ],
  },
]);

// Suppress unused-import warning in some toolchains
export { AppLayout };
